import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog } from "@angular/material";

import { PerfilService } from "src/app/services/ajs-perfil.service";
import { ModalComunicadosComponent } from "./notificacao/comunicados/modal.component";
import * as moment from "moment";
import { ComunicadosService } from "src/app/services/api/comunicados.service";

@Component({
  selector: "mandae-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"]
})
export class DashboardComponent implements OnInit {
  private comunicadosToShow: any[] = [];
  private currentComunicadoIndex = 0;

  constructor(
    public dialog: MatDialog,
    @Inject(PerfilService) public profile: PerfilService,
    public comunicadosService: ComunicadosService,
  ) {}

  async ngOnInit() {
    await this.checkComunicados();
    this.checkPlataformaIntegracao();
  }

  public async checkComunicados() {
    const data = await this.comunicadosService.getComunicadosAtivos();

    if (data && data.length > 0) {
      this.comunicadosToShow = data;
      this.currentComunicadoIndex = 0;
      this.openNextComunicado();
    }
  }

  private openNextComunicado() {
    if (this.currentComunicadoIndex >= this.comunicadosToShow.length) {
      return;
    }

    const user = localStorage.getItem('ls.user')
      ? JSON.parse(localStorage.getItem('ls.user'))
      : null;

    const currentComunicado = this.comunicadosToShow[this.currentComunicadoIndex];
    const chaveExpiracaoComunicado = `ls.comunicado.id_${currentComunicado.idComunicado}.id_cliente_${user.id}.expiracao`;
    const dataExpiracaoComunicado = localStorage.getItem(chaveExpiracaoComunicado);
    const daquiASeteDias = moment().add(7, 'days');

    if (dataExpiracaoComunicado && moment(dataExpiracaoComunicado).isBefore(daquiASeteDias)) {
      this.currentComunicadoIndex++;
      this.openNextComunicado();
      return;
    }

    this.dialog.open(ModalComunicadosComponent, {
      width: "45vw",
      maxWidth: "80vw",
      closeOnNavigation: false,
      disableClose: true,
      panelClass: "modal-notificacao",
      data: currentComunicado
    }).afterClosed().subscribe((ciente) => {
      if (ciente) {
        localStorage.setItem(chaveExpiracaoComunicado, daquiASeteDias.format('YYYY-MM-DD HH:mm:ss'));
      }

      this.currentComunicadoIndex++;
      this.openNextComunicado();
    });
  }

  public checkPlataformaIntegracao() {
    const data = sessionStorage.getItem("webapp.plataforma");

    if (data) {
      const position = data.split("&");

      switch (position[1]) {
        case "acao=solicitarColeta":
          window.location.href = `pedido/encomendas${data}`;
          break;
        case "acao=gerarEtiquetas":
          window.location.href = `historico/encomendas${data}`;
          break;
      }
    }
  }
}
